<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="3">
          <b-link :to="{ name: 'Merchants-list' }">
            <feather-icon icon="ArrowLeftIcon" />
            <span class="align-middle ml-50">Back to List</span>
          </b-link>
        </b-col>
      </b-row>

      <b-card-header>
        <h3>
          <strong>{{ this.$route.params.name }}</strong>
        </h3>
      </b-card-header>
      <b-card-body>
        <validation-observer ref="simpleRules">
          <form ref="form" @submit.stop.prevent="validationNewMerchantForm">
            <b-row>
              <b-col md="4">
                <b-form-group label="Name" label-for="name">
                  <validation-provider
                    #default="{ errors }"
                    name="Name"
                    rules="required"
                  >
                    <b-form-input
                      id="name-input"
                      v-model="editMerchantFormData.name"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Company" label-for="companyId">
                  <validation-provider #default="{ errors }" name="companyId">
                    <b-form-select
                      id="input-3"
                      v-model="editMerchantFormData.companyId"
                      :options="companyIdOptions"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Merchant Identifier"
                  label-for="merchantIdentifier"
                >
                  <validation-provider #default="{ errors }" name="pendingURI">
                    <b-form-input
                      id="merchantIdentifier-input"
                      v-model="editMerchantFormData.merchantIdentifier"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Account Group" label-for="accountGroup">
                  <validation-provider
                    #default="{ errors }"
                    name="accountGroup"
                  >
                    <b-form-select
                      id="input-3"
                      v-model="editMerchantFormData.accountGroup"
                      :options="accountGroupEnum"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Channel" label-for="channel">
                  <validation-provider
                    #default="{ errors }"
                    name="Channel"
                    rules="required"
                  >
                    <b-form-input
                      id="channel-input"
                      v-model="editMerchantFormData.channel"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Bank Short Code" label-for="bankShortCode">
                  <validation-provider
                    #default="{ errors }"
                    name="bankShortCode"
                  >
                    <b-form-input
                      id="bankShortCode-input"
                      v-model="editMerchantFormData.bankShortCode"
                      :state="errors.length > 0 ? false : null"
                      disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Authorization Short Code"
                  label-for="authorizationShortCode"
                >
                  <validation-provider #default="{ errors }" name="pendingURI">
                    <b-form-input
                      id="authorizationShortCode-input"
                      v-model="editMerchantFormData.authorizationShortCode"
                      :state="errors.length > 0 ? false : null"
                      disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="CBE Short Code"
                  label-for="cbeBirrShortCode"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="cbeBirrShortCode"
                  >
                    <b-form-input
                      id="bankShortCode-input"
                      v-model="editMerchantFormData.cbeBirrShortCode"
                      :state="errors.length > 0 ? false : null"
                      disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Tele Birr Short Code"
                  label-for="teleBirrShortCode"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="teleBirrShortCode"
                  >
                    <b-form-input
                      id="teleBirrShortCode-input"
                      v-model="editMerchantFormData.teleBirrShortCode"
                      :state="errors.length > 0 ? false : null"
                      disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Default Expiry Hour"
                  label-for="defaultExpiryHour"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="pendingURI"
                    rules="required"
                  >
                    <b-form-input
                      id="defaultExpiryHour-input"
                      v-model.number="editMerchantFormData.defaultExpiryHour"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="Merchant Need Own OrderCode"
                  label-for="merchantNeedOwnOrderCode"
                >
                  <b-form-checkbox
                    id="merchantNeedOwnOrderCode-input"
                    v-model="editMerchantFormData.merchantNeedOwnOrderCode"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Approve URI" label-for="approvedURI">
                  <validation-provider
                    #default="{ errors }"
                    name="approvedURI"
                    rules="required"
                  >
                    <b-form-input
                      id="approvedURI-input"
                      v-model="editMerchantFormData.approvedURI"
                      :state="errors.length > 0 ? false : null"
                      disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Return URI" label-for="returnURI">
                  <validation-provider
                    #default="{ errors }"
                    name="returnURI"
                    rules="required"
                  >
                    <b-form-input
                      id="returnURI-input"
                      v-model="editMerchantFormData.returnURI"
                      :state="errors.length > 0 ? false : null"
                      disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Declined URI" label-for="declinedURI">
                  <validation-provider #default="{ errors }" name="declinedURI">
                    <b-form-input
                      id="declinedURI-input"
                      v-model="editMerchantFormData.declinedURI"
                      :state="errors.length > 0 ? false : null"
                      disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Pending URI" label-for="pendingURI">
                  <validation-provider #default="{ errors }" name="pendingURI">
                    <b-form-input
                      id="pendingURI-input"
                      v-model="editMerchantFormData.pendingURI"
                      :state="errors.length > 0 ? false : null"
                      disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Cancel URI" label-for="cancelURI">
                  <validation-provider
                    #default="{ errors }"
                    name="cancelURI"
                    rules="required"
                  >
                    <b-form-input
                      id="cancelURI-input"
                      v-model="editMerchantFormData.cancelURI"
                      :state="errors.length > 0 ? false : null"
                      disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Refund Confirmation Notify URL"
                  label-for="refundConfirmationNotifyURL"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="refundConfirmationNotifyURL"
                  >
                    <b-form-input
                      id="refundConfirmationNotifyURL-input"
                      v-model="editMerchantFormData.refundConfirmationNotifyURL"
                      :state="errors.length > 0 ? false : null"
                      disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Refund Capping Limit"
                  label-for="refundCappingLimit"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="refundCappingLimit"
                    rules="required"
                  >
                    <b-form-input
                      id="refundCappingLimit-input"
                      v-model.number="editMerchantFormData.refundCappingLimit"
                      :state="errors.length > 0 ? false : null"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Refund Action WorkFlow Required MinimumAmount"
                  label-for="refundActionWorkFlowRequiredMinimumAmount"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="refundActionWorkFlowRequiredMinimumAmount"
                    rules="required"
                  >
                    <b-form-input
                      id="refundActionWorkFlowRequiredMinimumAmount-input"
                      v-model.number="
                        editMerchantFormData.refundActionWorkFlowRequiredMinimumAmount
                      "
                      :state="errors.length > 0 ? false : null"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Max Days Refund Is Allowed"
                  label-for="noOfMaxDaysRefundIsAllowed"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="noOfMaxDaysRefundIsAllowed"
                    rules="required"
                  >
                    <b-form-input
                      id="noOfMaxDaysRefundIsAllowed-input"
                      v-model.number="
                        editMerchantFormData.noOfMaxDaysRefundIsAllowed
                      "
                      :state="errors.length > 0 ? false : null"
                      type="number"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Confirm Retry Required"
                  label-for="confirmRetryRequired"
                >
                  <b-form-checkbox
                    id="confirmRetryRequired-input"
                    v-model="editMerchantFormData.confirmRetryRequired"
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-if="editMerchantFormData.confirmRetryRequired === true"
                md="4"
              >
                <b-form-group
                  label="Confirmation Retrial Attempt Allowed Count"
                  label-for="confirmRetrialAttemptAllowedCount"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="confirmRetrialAttemptAllowedCount"
                  >
                    <b-form-input
                      id="confirmRetrialAttemptAllowedCount-input"
                      v-model.number="
                        editMerchantFormData.confirmRetrialAttemptAllowedCount
                      "
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Refund Confirmation Email"
                  label-for="refundConfirmationEmail"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="refundConfirmationEmail"
                  >
                    <b-form-input
                      id="refundConfirmationEmail-input"
                      v-model="editMerchantFormData.refundConfirmationEmail"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Refund Access Type">
                  <b-form-select
                    id="input-3"
                    v-model="editMerchantFormData.refundAccessType"
                    :options="refundAccessTypeOptions"
                    @input="ChangeAssignedUser"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Refund To Separate Account"
                  label-for="refundToSeparateAccount"
                >
                  <b-form-checkbox
                    id="refundToSeparateAccount-input"
                    v-model="editMerchantFormData.refundToSeparateAccount"
                  />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="Is Reconcilation Needed"
                  label-for="isReconcilationNeeded"
                >
                  <b-form-checkbox
                    id="isReconcilationNeeded-input"
                    v-model="editMerchantFormData.isReconcilationNeeded"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Refund Action WorkFlow Required"
                  label-for="refundActionWorkFlowRequired"
                >
                  <b-form-checkbox
                    id="refundActionWorkFlowRequired-input"
                    v-model="editMerchantFormData.refundActionWorkFlowRequired"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group
                  label="Send Email When User Assigned For Refund WorkFlow"
                  label-for="sendEmailWhenUserAssignedForRefundWorkFlow"
                >
                  <b-form-checkbox
                    id="sendEmailWhenUserAssignedForRefundWorkFlow-input"
                    v-model="
                      editMerchantFormData.sendEmailWhenUserAssignedForRefundWorkFlow
                    "
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <app-collapse
              accordion
              v-if="editMerchantFormData.refundActionWorkFlowRequired"
            >
              <app-collapse-item
                title="Refund Workflow configuration"
                :is-visible="true"
              >
                <div>
                  <div>
                    <b-row
                      v-for="(item, index) in items"
                      :id="item.id"
                      :key="index"
                      ref="row"
                    >
                      <b-col md="4">
                        <b-form-group label="Level" label-for="item-name">
                          <b-form-input
                            id="item-name"
                            v-model="item.level"
                            type="number"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col md="4">
                        <validation-provider
                          #default="{ errors }"
                          name="Assigned User Email"
                          rules="required"
                        >
                          <b-form-group
                            label="Assigned User Email"
                            label-for="email"
                          >
                            <v-select
                              v-model="item.userId"
                              :options="users"
                              label="text"
                              :clearable="true"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </b-form-group>
                        </validation-provider>
                      </b-col>

                      <b-col lg="2" md="3" class="mb-50">
                        <b-button
                          variant="outline-danger"
                          class="mt-0 mt-md-2"
                          @click="removeItem(index)"
                        >
                          <feather-icon icon="XIcon" class="mr-25" />
                          <span>Delete</span>
                        </b-button>
                      </b-col>
                      <b-col cols="12">
                        <hr />
                      </b-col>
                    </b-row>
                  </div>
                  <b-button variant="primary" @click="repeateAgain">
                    <feather-icon icon="PlusIcon" class="mr-25" />
                    <span>Next Level</span>
                  </b-button>
                </div>
              </app-collapse-item>
            </app-collapse>

            <br />
            <br />
            <b-button
              variant="primary"
              type="submit"
              @click.prevent="validationNewMerchantForm"
            >
              Save
            </b-button>
          </form>
        </validation-observer>
      </b-card-body>

      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BCard,
  BButton,
  BFormCheckbox,
  BCardBody,
  BCardHeader,
  BFormSelect,
  BOverlay,
  BLink,
} from "bootstrap-vue";
import { heightTransition } from "@core/mixins/ui/transition";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import axios from "@axios";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BCard,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    AppCollapse,
    AppCollapseItem,
    BCardBody,
    BCardHeader,
    BOverlay,
    vSelect,
    BLink,
    ToastificationContent,
  },
  mixins: [heightTransition],
  data() {
    return {
      isLoading: false,
      required,
      editMerchantFormData: {
        id: 12,
        name: "",
        merchantLogo: "stringLogo",
        channel: "",
        cancelURI: "",
        pendingURI: "",
        approvedURI: "",
        returnURI: "",
        declinedURI: "",
        merchantIdentifier: "",
        accountGroup: null,
        authorizationShortCode: "",
        companyId: 1,
        defaultExpiryHour: 0,
        refundCappingLimit: 0,
        refundToSeparateAccount: false,
        refundActionWorkFlowRequired: false,
        refundActionWorkFlowRequiredMinimumAmount: 0,
        refundConfirmationNotifyURL: "",
        refundConfirmationEmail: "",
        noOfMaxDaysRefundIsAllowed: 0,
        errorURI: "stringE1",
        bankShortCode: "",
        cbeBirrShortCode: "",
        teleBirrShortCode: "",
        sendEmailWhenUserAssignedForRefundWorkFlow: false,
        refundAccessType: 0,
        merchantNeedOwnOrderCode: false,
        confirmRetryRequired: false,
        isReconcilationNeeded: false,
        confirmRetrialAttemptAllowedCount: 0,
        refundWorkFlow: [],
      },
      accountGroupEnum: [
        { value: 1, text: "Revenue Ticket" },
        { value: 2, text: "E-Staff Ticket" },
        { value: 3, text: "Aviation University" },
        { value: 4, text: "Ethiopian Visa" },
        { value: 5, text: "Ethiopian Passport" },
        { value: 6, text: "Ethiopian OriginID" },
        { value: 7, text: "Ethiopian Cargo" },
      ],
      companyIdOptions: [],
      refundAccessTypeOptions: [
        { value: 1, text: "Gatway" },
        { value: 2, text: "Merchant" },
      ],
      selectedMerchantName: "",
      items: [
        {
          level: 1,
          userId: null,
          id: 0,
        },
      ],
      nextTodoId: 1,
      users: [],
      allUsers: [],
    };
  },
  mounted() {
    this.initTrHeight();
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
    this.fetchData();
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Merchants-Update");

      axios
        .get(
          `/Merchant/api/V1.0/Merchants/GetMerchantData?merchantId=${this.$route.params.id}`
        )
        .then((response) => {
          this.users = [];
          this.companyIdOptions = [];
          this.allUsers = response.users;
          if (response.users !== null) {
            response.users.forEach((item) => {
              this.users.push({
                value: item.id,
                text: item.username,
              });
            });
          }
          response.companies.forEach((item) => {
            this.companyIdOptions.push({
              value: item.id,
              text: item.name,
            });
          });

          axios
            .get(
              `/Merchant/api/V1.0/Merchants/GetById?id=${this.$route.params.id}`
            )
            .then((res) => {
              this.editMerchantFormData = res.merchant;
              if (res.merchant.refundWorkFlow.length > 0) {
                this.items = [];
                res.merchant.refundWorkFlow.forEach((item) => {
                  const selectedItem = this.users.filter(
                    (f) => f.value === item.userId
                  )[0];
                  this.items.push({
                    id: item.id,
                    level: item.level,
                    userId: {
                      value: selectedItem.value,
                      text: selectedItem.text,
                    },
                  });
                  this.nextTodoId = item.level;
                });
              }
              this.isLoading = false;
            })
            .catch((res) => {
              console.log(res);
              this.isLoading = false;
            });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    validationNewMerchantForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          if (this.editMerchantFormData.refundActionWorkFlowRequired) {
            this.editMerchantFormData.refundWorkFlow = [];
            this.isLoading = true;
            this.items.forEach((item) => {
              this.editMerchantFormData.refundWorkFlow.push({
                level: item.level,
                userId: item.userId.value,
                id: item.id,
              });
            });
          }

          axios
            .put(
              "/Merchant/api/V1.0/Merchants/Update",
              this.editMerchantFormData
            )
            .then((res) => {
              this.isLoading = false;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Data Submitted",
                  icon: "EditIcon",
                  variant: "success",
                  message: res.message,
                },
              });
              this.$router.push({ name: "Merchants-list" });
            })
            .catch((res) => {
              console.log(res.config.data);
              this.isLoading = false;
              // eslint-disable-next-line no-alert
              this.$bvModal.msgBoxOk(res.data.message, {
                title: "Error",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
              });
            });
        }
      });
    },
    repeateAgain() {
      this.nextTodoId += 1;
      this.items.push({
        level: this.nextTodoId,
        userId: null,
        id: 0,
      });
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.nextTodoId -= 1;
      this.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    ChangeAssignedUser() {
      this.isLoading = true;
      const usersFiltered = this.allUsers?.filter(
        (f) => f.accessType === this.editMerchantFormData.refundAccessType
      );
      this.users = [];
      if (usersFiltered != null) {
        usersFiltered.forEach((item) => {
          this.users.push({
            value: item.id,
            text: item.username,
          });
        });
      }
      this.isLoading = false;
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form);
      });
    },
  },
};
</script>
